import React from 'react';
import cx from 'classnames';

import SaveBanner from '../SaveBanner';
import './styles.scss';

const MainBanner = ({ getCouponContentKey, planSelected }) => (
  <section className={cx('main-banner', planSelected)}>
    <h1 className="banner-title">
      {getCouponContentKey('title', 'Reactivate Your Membership')}
    </h1>
    <h4 className="banner-subtitle">
      {getCouponContentKey('subtitle', 'Reactivate to Annual to instantly save money!')}
    </h4>
    <SaveBanner getCouponContentKey={getCouponContentKey} />
  </section>
);

MainBanner.displayName = 'MainBanner';

MainBanner.defaultProps = {
  planSelected: '',
};

export default MainBanner;
